import React from "react";
import { Route } from "react-router-dom";
import Receiving from "../../../containers/modules/purchasing/receiving";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import CashBank from "../../../containers/modules/report/cash-bank";

export default function CashBankRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="cash-bank"
      index
      element={
        <AccessControl
          name={"Cash Bank Book Show"}
          auth={authUser}
          component={() => <CashBank />}
        />
      }
    ></Route>
  );
}
